import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { Container } from './styles';
import { TooltipIcon } from 'assets/icons';

const RoomQuantityTooltip = ({
  text
}) => {

  return (
    <>
      <style>
        {`
          .rc-tooltip-placement-right {
            z-index: 1000;
          }
          .rc-tooltip-placement-right > .rc-tooltip-arrow {
            top: 21px !important;  
          }
          .rc-tooltip-placement-right > .rc-tooltip-arrow::before {
            top: -16.5px;
          } 
        `}
      </style>
      <Tooltip
        placement="right"
        trigger={['hover']}
        overlay={
          <Container>
            <div className="tooltip-text">{text}</div>
          </Container>
        }
      >
        <TooltipIcon />
      </Tooltip>
    </>
  );
}

export default RoomQuantityTooltip;
